<template>
  <vue-recaptcha
    ref="vueRecaptchaRef"
    :sitekey="runtimeConfig.public.RECAPTCHA_SITE_KEY"
    size="normal"
    theme="light"
    :hl="LangList['es-ES']"
    class="t-recaptcha"
    @verify="recaptchaValidate"
    @expire="recaptchaValidate"
    @fail="recaptchaValidate"
  />
</template>

<script setup lang="ts">
// @ts-ignore: not able to find declaration file in the module
import vueRecaptcha from 'vue3-recaptcha2'
import { LangList } from '~/modules/lang/entities/Lang'

const runtimeConfig = useRuntimeConfig()

const model = defineModel({
  type: String,
})

const emit = defineEmits(['change'])
const vueRecaptchaRef = ref<vueRecaptcha | null>(null)
const recaptchaValidate = (response: string): void => {
  model.value = response
  emit('change', response)
}

function triggerReset() {
  vueRecaptchaRef.value?.reset()
}

defineExpose({
  triggerReset,
})
</script>
